// Copyright (c) 2021, HelmCyber, Inc.
'use strict'

import merge from 'deepmerge'
import PropTypes from 'prop-types'
import React, { useReducer } from 'react'

export const UiContext = React.createContext()

// Actions
export const RESET_ALERT_MODAL = 'RESET_ALERT_MODAL'
export const SET_ALERT_MODAL = 'SET_ALERT_MODAL'
export const SET_DATA_CAPTURED = 'SET_DATA_CAPTURED'
export const SET_NAV = 'SET_NAV'
export const SET_NOTIFICATION_ROWS = 'SET_NOTIFICATION_ROWS'
export const SET_NOTIFICATIONS_ERROR = 'SET_NOTIFICATIONS_ERROR'
export const SET_NOTIFICATIONS_EXPANDED = 'SET_NOTIFICATIONS_EXPANDED'
export const SET_SYSTEM_LOCK = 'SET_SYSTEM_LOCK'
export const SET_UNIT = 'SET_UNIT'
export const SET_USER = 'SET_USER'

const initialState = {
    alertModal: {
        show: false,
        title: null,
        subtitle: null,
        message: null,
        children: null,
        onClose: null,
        dismissable: true,
    },
    data: {
        captured: null,
        minTidEpoch: null,
        maxTidEpoch: null,
        mvTids: null,
        tidFold: null,
        tidSize: null,
    },
    nav: {
        width: 300,
    },
    notifications: {
        rows: [],
        expanded: false,
        error: null,
    },
    systemLock: {
        present: {
            job: null,
            locked: false,
            message: null,
        },
        pending: {
            job: null,
            locked: false,
            message: null,
        },
    },
    unit: {
        oemRelease: null,
        unitName: null,
        version: null,
    },
    user: {
        capabilities: [],
        displayName: null,
        filterHistory: [],
        username: null,
        uid: null,
        settings: {
            menuMaximized: true,
        },
        remote: false,
    },
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_ALERT_MODAL:
            return {
                ...state,
                alertModal: {
                    show: false,
                    title: 'Alert',
                    subtitle: 'Something went wrong',
                    message: 'Please contact the system administrator if the problem presists',
                    children: null,
                    onClose: null,
                    dismissable: true,
                },
            }
        case SET_ALERT_MODAL:
            var alertModal = Object.assign({}, state.alertModal, action.alertModal)
            return { ...state, alertModal }
        case SET_DATA_CAPTURED:
            var data = merge(state.data, action.data)
            return { ...state, data }
        case SET_NAV:
            var nav = merge(state.nav, action.nav)
            return { ...state, nav }
        case SET_NOTIFICATION_ROWS:
            var notificationRows = { rows: Array.from(action.rows) }
            var notifications = Object.assign({}, state.notifications, notificationRows)
            return { ...state, notifications }
        case SET_NOTIFICATIONS_EXPANDED:
            var notificationsExpanded = Object.assign({}, state.notifications, { expanded: action.expanded })
            return { ...state, notifications: notificationsExpanded }
        case SET_SYSTEM_LOCK:
            var systemLock = merge(state.systemLock, action.systemLock, { clone: true })
            return { ...state, systemLock }
        case SET_UNIT:
            var unit = Object.assign({}, state.unit, action.unit)
            return { ...state, unit }
        case SET_USER:
            var user = merge(state.user, action.user, { clone: true, arrayMerge: (dest, source) => source })
            return { ...state, user }
        default:
            return state
    }
}

//eslint-disable-next-line react/prop-types
export const UiContextProvider = ({ children, value = initialState }) => {
    const uiContext = useReducer(reducer, value)
    return <UiContext.Provider value={uiContext}>{children}</UiContext.Provider>
}

UiContextProvider.propTypes = {
    children: PropTypes.object,
}
